import { Epic } from "redux-observable";
import { switchMap, filter } from "rxjs/operators";
import { Observable } from "rxjs";
import { IState, Dependencies } from "../@types";
import { RootAction } from "../actions";
import { isActionOf } from "typesafe-actions";
import { usersActionsAsync } from "../actions/usersActions";
import { Auth } from "aws-amplify";


export const deleteUserEpic: Epic<
    RootAction,
    RootAction,
    IState,
    Dependencies
> = (action$, state$, dependencies) => {
    return action$.pipe(
        filter(isActionOf(usersActionsAsync.deleteUser.request)),
        switchMap(action => {
            return new Observable<RootAction>(observer => {
                const state = state$.value as IState;
                const { apiGatewayUrl } = state.constants;
                const { userId } = action.payload;
                async function deleteUser() {
                    const session = await Auth.currentSession();
                    const token = session.getIdToken().getJwtToken();

                    const deletedUserId = await dependencies.usersApi.deleteUser({
                        apiGatewayUrl,
                        token,
                        userId
                    });
                    observer.next(usersActionsAsync.deleteUser.success({ userId }));
                }
                deleteUser().catch(error => {
                    console.log(error);
                    observer.next(usersActionsAsync.deleteUser.failure({ error }));
                });
            });
        })
    );
}